import { createContext, ReactNode, useContext, useMemo } from 'react';

import { useGlobalStore } from '../state/globalStore';
import { ENTITY_TYPE, FEATURES } from '../utils/constants';
import { Enum, Features, UserProps } from '../utils/types';

interface IfeatureFlowContext {
  features: Features;
  setFeatures?: React.Dispatch<React.SetStateAction<Features>>;
}

const FeatureFlowContext = createContext<IfeatureFlowContext>({
  features: {
    [FEATURES.CONFIRMATION_VIEW]: true,
  },
  setFeatures: () => undefined,
});

type Props = {
  children: ReactNode;
} & UserProps;

export const FeatureFlowProvider = ({ children }: Props) => {
  const entityType = useGlobalStore((store) => store.entityType);
  const features = useMemo<Features>(
    () => ({
      [FEATURES.CONFIRMATION_VIEW]: entityType !== ENTITY_TYPE.SHOWCASE,
    }),
    [entityType],
  );

  return <FeatureFlowContext.Provider value={{ features }}>{children}</FeatureFlowContext.Provider>;
};

export const useFeatureFlow = (feature: Enum<typeof FEATURES>) =>
  useContext<IfeatureFlowContext>(FeatureFlowContext).features[feature];
